/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect, useReducer, useRef } from "react";
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
import { useVueProps, vueDefaultValue } from "common/vue/useVueProps";
/* eslint-disable max-lines-per-function */
import "./Tooltip.react.scss";
// Delay before allowing click-outside handler to fire after toggling
// Prevents the tooltip from immediately closing when clicking the target element
const CLICK_OUTSIDE_DELAY_MS = 100;

// @ts-ignore TS(6133): 'rawProps' is declared but its value is never read... Remove this comment to see the full error message
function getDefaultProps(rawProps: any) {
  return {
    disabled: vueDefaultValue(false),
    position: vueDefaultValue("top"),
    trigger: vueDefaultValue("hover"),
    customPosition: vueDefaultValue(null)
  };
}

export default function VueTooltip(rawProps: any) {
  const { className, disabled, position, trigger, customPosition, ...restProps } = rawProps;

  const props = useVueProps(rawProps, getDefaultProps);
  const [_, forceUpdate] = useReducer(() => ({}), {});
  const isVisible = useRef(false);
  const toggleTimeout = useRef(null);

  function customPositionStyle() {
    if (!props.current.customPosition) return {};
    return {
      position: "absolute",
      ...props.current.customPosition
    };
  }

  function showTooltip() {
    if (props.current.disabled) return;
    isVisible.current = true;
    forceUpdate();
    props.current.onShow?.();
  }

  function hideTooltip() {
    if (props.current.disabled) return;
    isVisible.current = false;
    forceUpdate();
    props.current.onHide?.();
  }

  function toggleTooltip() {
    if (props.current.disabled) return;
    // @ts-ignore TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    clearTimeout(toggleTimeout.current);
    isVisible.current = !isVisible.current;
    forceUpdate();
    if (isVisible.current) {
      // @ts-ignore TS(2322): Type 'number' is not assignable to type 'null'.
      toggleTimeout.current = setTimeout(() => {
        toggleTimeout.current = null;
        forceUpdate();
      }, CLICK_OUTSIDE_DELAY_MS);
      forceUpdate();
      props.current.onShow?.();
    } else {
      props.current.onHide?.();
    }
  }

  // @ts-ignore TS(6133): 'handleClickOutside' is declared but its value is ... Remove this comment to see the full error message
  function handleClickOutside() {
    if (toggleTimeout.current || !isVisible.current) return;
    hideTooltip();
  }

  useEffect(() => {
    return () => {
      // @ts-ignore TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      clearTimeout(toggleTimeout.current);
    };
  }, []);

  return (
    // @ts-ignore TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
    <div {...filterDomProps(restProps)} className={cn("vue-tooltip scope-aca0e50a", className)}>
      <div
        className={cn("vue-tooltip__target", "scope-aca0e50a")}
        onMouseEnter={() => {
          props.current.trigger === "hover" && showTooltip();
        }}
        onMouseLeave={() => {
          props.current.trigger === "hover" && hideTooltip();
        }}
        onClick={e => {
          e.stopPropagation();
          // @ts-ignore TS(2349): This expression is not callable.
          (props.current.trigger === "click" && toggleTooltip())(e);
        }}
        data-testid="vue-tooltip-target"
      >
        {props.current?.slots?.target?.()}
      </div>
      {isVisible.current ? (
        <div
          className={cn("vue-tooltip__content scope-aca0e50a", [
            `vue-tooltip__content--${props.current.position}`,
            {
              "vue-tooltip__content--custom": props.current.customPosition
            }
          ])}
          style={customPositionStyle()}
        >
          {props.current?.slots?.content?.()}
        </div>
      ) : null}
    </div>
  );
}
